<div class="app-footer-container">
  <div fxLayout="row" class="app-footer-container__item">
    <app-version-banner fxFlex></app-version-banner>
  </div>
  <a class="app-footer-container__item"
    [href]="getFeedbackMailLink()">Feedback</a>
</div>
